var styleDataHash = "f2c55c69";
const injectCss = (() => {
  var css = `.Y7IXq{background-color:var(--ricos-settings-dividers-color,#ededed);height:var(--ricos-settings-dividers-height,36px);margin-block:-3px;width:1px}._2yUIr{height:42px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var toolbar_button_separator_default = {
  "separator": "Y7IXq",
  "mobileSeparator": "_2yUIr"
};
export {
  toolbar_button_separator_default as default,
  injectCss
};
//# sourceMappingURL=toolbar-button-separator-scss.js.map
